import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { login } from '../utils/api';

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await login(username, password);
      if (response.data.success) {
        localStorage.setItem('user', JSON.stringify(response.data.user));
        navigate('/');
      }
    } catch (err) {
      setError('Invalid username or password');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen px-4">
      <div className="w-full max-w-md bg-[#1C1C1E] rounded-[32px] p-8 border border-[#2C2C2E]">
        <h1 className="text-4xl font-black italic tracking-tighter mb-8 text-center">TRAK-PLAY</h1>
        
        {error && <p className="text-red-500 mb-4 text-center">{error}</p>}
        
        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            id="username"
            name="username"
            type="text"
            placeholder="Username"
            autoComplete="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            className="w-full bg-[#2C2C2E] border border-transparent focus:border-[#A3E635] outline-none rounded-full px-6 py-4 transition-all"
          />
          <input
            id="password"
            name="password"
            type="password"
            placeholder="Password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="w-full bg-[#2C2C2E] border border-transparent focus:border-[#A3E635] outline-none rounded-full px-6 py-4 transition-all"
          />
          <button
            type="submit"
            className="w-full bg-[#A3E635] text-black font-black rounded-full py-4 text-xl hover:scale-105 transition-transform shadow-[0_0_20px_rgba(163,230,53,0.2)]"
          >
            LOGIN
          </button>
        </form>
      </div>
    </div>
  );
};

export default Login;
